import { gql } from '@apollo/client';

export const GET_VANITY_DUPLICATE_COMPENSATION_CONFIG = gql`
  query getVanityDuplicateCompensationConfig {
    liveOps {
      id
      vanityDuplicateCompensationConfig {
        sticker
        profileFrame
        appSkin
        badge
        emoji
        emojiPack
      }
    }
  }
`;

export const UPDATE_VANITY_DUPLICATE_COMPENSATION_CONFIG = gql`
  mutation updateVanityDuplicateCompensationConfig($input: VanityDuplicateCompensationConfigInput!) {
    updateVanityDuplicateCompensationConfig(input: $input) {
      sticker
      profileFrame
      appSkin
      badge
      emoji
      emojiPack
    }
  }
`;
